module.exports = __webpack_public_path__ + "static/media/back-ico-80x80.603f679d.png";